import { defineStore } from 'pinia';
import type { ModalState } from '@/app/model/types/modals';

export const useModalsStore = defineStore('modals', () => {
  const modalState = ref<ModalState>({
    auth: false,
    personal: false,
    payment: false,
    address: false,
    product: false,
  });

  const isAuthModalOpen = computed(() => modalState.value.auth);
  const isProfileModalOpen = computed(() =>
    modalState.value.personal ||
    modalState.value.payment ||
    modalState.value.address
  );

  const setModalState = (
    modalType: keyof ModalState,
    value: boolean = false,
  ) => {
    modalState.value[modalType] = value;
  };

  const closeAllModals = () => {
    modalState.value.auth = false;
    modalState.value.personal = false;
    modalState.value.payment = false;
    modalState.value.address = false;
    modalState.value.product = false;
  };

  return {
    modalState,
    isAuthModalOpen,
    isProfileModalOpen,
    setModalState,
    closeAllModals,
  };
});
